import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Cookies from "universal-cookie";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Rating from "./sub-components/ProductRating";
import { getMultiLangProperty } from "../../../helpers/generalHelper";
import actions, { useActions } from "../../../redux/actions";
import ErrorHandler from "../../../base/ErrorHandler";
import QRCodeScanner from "../../../components/QRCodeScanner";
import QRCodeScannerHooks from "../../../components/QRCodeScanner/hooks";

const cookies = new Cookies();

const ProductGridListSingle = ({
  product,
  currency,
  addToCart,
  cartItem,
  wishlistItem,
  sliderClassName,
  spaceBottomClass,
}) => {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const token = cookies.get("token", { path: "/" });
  const allowLinksell = cookies.get("allowLinksell", { path: "/" }) === "true";
  const role = cookies.get("role", { path: "/" });
  const tier = cookies.get("tier", { path: "/" });
  const {
    isQRScannerOpen,
    setIsQRScannerOpen,
    setSelectedProduct,
    onSingleProductScan,
  } = QRCodeScannerHooks.useLinkSellScanner();

  const WishlistActions = useActions(actions.WishlistActions);

  const { originalPrice, price, isReward, point } = product;
  const finalProductPrice = (price * currency.currencyRate).toFixed(2);

  const onClickWishlist = (id) => {
    if (token) {
      WishlistActions.create(token, { product: id })
        .then(() => WishlistActions.fetchAll(token))
        .catch(ErrorHandler);
    } else {
      history.push("/login-register");
    }
  };

  function renderActionButton() {
    const {
      affiliateLink,
      isInStock,
      type,
      _id,
      qty,
      tierRestriction,
    } = product;
    const hasAffiliateLink = !!affiliateLink;
    // const addedToCart = cartItem && cartItem.qty > 0;

    const hasTierRestriction =
      Array.isArray(tierRestriction) && tierRestriction.length >= 1;
    const isTierAllowed = hasTierRestriction
      ? tierRestriction.some(({ _id: tierId }) => tierId === tier)
      : true;

    if (role === "admin") {
      return (
        <button disabled className="active">
          {t("productList.outOfStock")}
        </button>
      );
    }

    if (!isTierAllowed) {
      return (
        <OverlayTrigger
          placement="top"
          delay={{ show: 250, hide: 400 }}
          overlay={(
            <Tooltip id="button-tooltip">
              {t("productList.tierRestriction")}
            </Tooltip>
          )}
          trigger={["hover", "click"]}
        >
          <div style={{ width: "100%" }}>
            <button
              disabled
              className="active"
              type="button"
              style={{ pointerEvents: "none" }}
            >
              {t("productList.outOfStock")}
            </button>
          </div>
        </OverlayTrigger>
      );
    }

    if (hasAffiliateLink) {
      return (
        <a
          href={product.affiliateLink}
          rel="noopener noreferrer"
          target="_blank"
          title={t("productList.buyNow")}
        />
      );
    }

    if (isInStock && (type === "credit" || isReward)) {
      if (allowLinksell) {
        return (
          <button
            onClick={() => {
              setSelectedProduct(product);
              setIsQRScannerOpen(true);
            }}
          >
            {t("checkout.checkout")}
          </button>
        );
      }
      return (
        <Link
          to={{
            pathname: `${process.env.PUBLIC_URL}/checkout`,
            state: { productID: _id },
          }}
        >
          {t("checkout.checkout")}
        </Link>
      );
    }

    if (["configurable", "virtual"].indexOf(type) >= 0) {
      return (
        <Link to={`${process.env.PUBLIC_URL}/product/${product.slug}`}>
          {t("productList.selectOptions")}
        </Link>
      );
    }

    if (isInStock && type !== "credit") {
      const disabled = !isInStock || (cartItem && qty <= cartItem?.qty);
      return (
        <button
          disabled={disabled}
          style={{ cursor: disabled ? "not-allowed" : "auto" }}
          onClick={() => addToCart(product._id, 1)}
        >
          <i className="pe-7s-cart" />
          &nbsp;
          {t("productDetails.addToCart")}
        </button>

        // <button
        //   onClick={() => {
        //     addToCart(product._id, 1);
        //   }}
        //   className={addedToCart ? "active" : ""}
        //   disabled={addedToCart}
        //   title={
        //     addedToCart
        //       ? t("productList.addedToCart")
        //       : t("productList.addToCart")
        //   }
        // >
        //   <i className="pe-7s-cart" />
        //   {addedToCart
        //     ? t("productList.addedToCart")
        //     : t("productList.addToCart")}
        // </button>
      );
    }

    return (
      <button disabled className="active">
        {t("productList.outOfStock")}
      </button>
    );
  }

  function renderProductAction() {
    return (
      <div className="product-action">
        <div className="pro-same-action pro-wishlist">
          <button
            className={wishlistItem !== undefined ? "active" : ""}
            disabled={wishlistItem !== undefined}
            title={
              wishlistItem !== undefined
                ? t("productList.addedToWishlist")
                : t("productList.addToWishlist")
            }
            onClick={() => onClickWishlist(product._id)}
          >
            <i className="pe-7s-like" />
          </button>
        </div>
        <div className="pro-same-action pro-cart">{renderActionButton()}</div>
        <div className="pro-same-action pro-quickview">
          <button
            onClick={() => history.push(`/product/${product.slug}`)}
            title={t("productList.view")}
          >
            <i className="pe-7s-look" />
          </button>
        </div>
      </div>
    );
  }

  function renderProductImage() {
    return (
      <div className="product-img mb-3">
        <Link to={`${process.env.PUBLIC_URL}/product/${product.slug}`}>
          <img
            className="default-img two-column-img"
            src={
              Array.isArray(product.media) && product.media.length >= 1
                ? product.media[0].fileUrl
                : require("../../../assets/no-image.png")
            }
            alt=""
          />
          {Array.isArray(product.media) && product.media.length > 1 && (
            <img
              className="hover-img"
              src={
                product.media[1].fileUrl ||
                require("../../../assets/no-image.png")
              }
              alt=""
            />
          )}
        </Link>
        {(product.discount || product.new) && (
          <div className="product-img-badges">
            {product.discount && (
              <span className="pink">{`-${product.discount}%`}</span>
            )}
            {product.new && (
              <span className="purple">{t("productList.new")}</span>
            )}
          </div>
        )}

        {renderProductAction()}
      </div>
    );
  }

  function renderProductTitle() {
    return (
      <div style={{ height: 60, maxHeight: 60, overflow: "hidden" }}>
        <h3>
          <Link to={`${process.env.PUBLIC_URL}/product/${product.slug}`}>
            {getMultiLangProperty(product.name, i18n.language)}
          </Link>
        </h3>
        {product.rating && product.rating > 0 && (
          <div className="product-rating">
            <Rating ratingValue={product.rating} />
          </div>
        )}
      </div>
    );
  }

  function renderProductPrice() {
    return (
      <div
        className="product-price"
        style={{
          display: "flex",
          justifyContent: "center",
          backgroundColor: "#f6f7f8",
          width: "auto",
          margin: 20,
          padding: "10px 0px",
          justifySelf: "flex-end",
        }}
      >
        {isReward ? (
          <>
            <span>{point}</span>
            {t("productList.point")}
          </>
        ) : originalPrice > finalProductPrice ? (
          <div className="product-details-price d-flex flex-row mt-0">
            <span className="old mr-0">
              {currency.currencySymbol + originalPrice}
            </span>
            <div>
              <span>
                {currency.currencySymbol + (finalProductPrice || "0")}
              </span>
              {currency.currencyName.toUpperCase()}
            </div>
          </div>
        ) : (
          <>
            <span>{currency.currencySymbol + (finalProductPrice || "0")}</span>
            {currency.currencyName.toUpperCase()}
          </>
        )}

        {/*
              <span>
                {currency.currencySymbol + (finalProductPrice || "0")}
              </span>
              {currency.currencyName.toUpperCase()} */}
      </div>
    );
  }

  return (
    <>
      <div className={`col-xl-4 col-sm-6 ${sliderClassName || ""}`}>
        <div className={`product-wrap ${spaceBottomClass || ""}`}>
          <div className="product-content text-center d-flex flex-column flex-grow-1">
            {renderProductImage()}
            {renderProductTitle()}
            {renderProductPrice()}
          </div>
        </div>
        <QRCodeScanner
          show={isQRScannerOpen}
          onHide={() => setIsQRScannerOpen(false)}
          onScan={onSingleProductScan}
        />
        {/* <div className="shop-list-wrap mb-30"> */}
        {/*  <div className="row"> */}
        {/*    <div className="col-xl-4 col-md-5 col-sm-6"> */}
        {/*      <div className="product-list-image-wrap"> */}
        {/*        <div className="product-img"> */}
        {/*          <Link to={`${process.env.PUBLIC_URL}/product/${product._id}`}> */}
        {/*            <img */}
        {/*              className="default-img img-fluid" */}
        {/*              src={ */}
        {/*                Array.isArray(product.media) && */}
        {/*                product.media.length >= 1 */}
        {/*                  ? product.media[0].fileUrl */}
        {/*                  : "" */}
        {/*              } */}
        {/*              alt="" */}
        {/*            /> */}
        {/*            {Array.isArray(product.media) && */}
        {/*              product.media.length > 1 && ( */}
        {/*                <img */}
        {/*                  className="hover-img img-fluid" */}
        {/*                  src={product.media[1].fileUrl} */}
        {/*                  alt="" */}
        {/*                /> */}
        {/*              )} */}
        {/*          </Link> */}
        {/*          {(product.discount || product.new) && ( */}
        {/*            <div className="product-img-badges"> */}
        {/*              {product.discount && ( */}
        {/*                <span className="pink">{`-${product.discount}%`}</span> */}
        {/*              )} */}
        {/*              {product.new && ( */}
        {/*                <span className="purple">{t("productList.new")}</span> */}
        {/*              )} */}
        {/*            </div> */}
        {/*          )} */}
        {/*        </div> */}
        {/*      </div> */}
        {/*    </div> */}
        {/*    <div className="col-xl-8 col-md-7 col-sm-6"> */}
        {/*      <div className="shop-list-content"> */}
        {/*        <h3> */}
        {/*          <Link to={`${process.env.PUBLIC_URL}/product/${product._id}`}> */}
        {/*            {getMultiLangProperty(product.name, i18n.language)} */}
        {/*          </Link> */}
        {/*        </h3> */}
        {/*        <div className="product-list-price"> */}
        {/*          <span> */}
        {/*            {currency.currencySymbol + (finalProductPrice || "0")} */}
        {/*          </span> */}
        {/*        </div> */}
        {/*        {product.rating && product.rating > 0 && ( */}
        {/*          <div className="rating-review"> */}
        {/*            <div className="product-list-rating"> */}
        {/*              <Rating ratingValue={product.rating} /> */}
        {/*            </div> */}
        {/*          </div> */}
        {/*        )} */}
        {/*        {product.shortDescription && <p>{product.shortDescription}</p>} */}

        {/*        <div className="shop-list-actions d-flex align-items-center"> */}
        {/*          <div className="shop-list-btn btn-hover"> */}
        {/*            {renderActionButton()} */}
        {/*          </div> */}

        {/*          <div className="shop-list-wishlist ml-10"> */}
        {/*            <button */}
        {/*              className={wishlistItem !== undefined ? "active" : ""} */}
        {/*              disabled={wishlistItem !== undefined} */}
        {/*              title={ */}
        {/*                wishlistItem !== undefined */}
        {/*                  ? t("productList.addedToWishlist") */}
        {/*                  : t("productList.addToWishlist") */}
        {/*              } */}
        {/*              onClick={() => */}
        {/*                WishlistActions.updateWishlist( */}
        {/*                  { */}
        {/*                    option: product.skus[0].options[0], */}
        {/*                    action: !wishlistItem ? "add" : "remove", */}
        {/*                  }, */}
        {/*                  cookies.get("token") */}
        {/*                ) */}
        {/*                  .then((respose) => */}
        {/*                    WishlistActions.fetchWishlist(cookies.get("token")) */}
        {/*                  ) */}
        {/*                  .catch(ErrorHandler) */}
        {/*              } */}
        {/*            > */}
        {/*              <i className="pe-7s-like" /> */}
        {/*            </button> */}
        {/*          </div> */}
        {/*          <div className="shop-list-compare ml-10"> */}
        {/*            <button */}
        {/*              className={compareItem !== undefined ? "active" : ""} */}
        {/*              disabled={compareItem !== undefined} */}
        {/*              title={ */}
        {/*                compareItem !== undefined */}
        {/*                  ? t("productList.addedToCompare") */}
        {/*                  : t("productList.addToCompare") */}
        {/*              } */}
        {/*              onClick={() => addToCompare(product)} */}
        {/*            > */}
        {/*              <i className="pe-7s-shuffle" /> */}
        {/*            </button> */}
        {/*          </div> */}
        {/*        </div> */}
        {/*      </div> */}
        {/*    </div> */}
        {/*  </div> */}
        {/* </div> */}
      </div>
    </>
  );
};

ProductGridListSingle.propTypes = {
  cartItem: PropTypes.object,
  currency: PropTypes.object,
  product: PropTypes.object,
  sliderClassName: PropTypes.string,
  spaceBottomClass: PropTypes.string,
  wishlistItem: PropTypes.object,
};

export default ProductGridListSingle;
